"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Alert = (_a) => {
    var { color = 'primary', isOpen = true, toggle, className = '', fade = true, children } = _a, props = __rest(_a, ["color", "isOpen", "toggle", "className", "fade", "children"]);
    if (!isOpen)
        return null;
    const alertClasses = (0, classnames_1.default)('alert', `alert-${color}`, { 'alert-dismissible': toggle }, { fade, show: fade && isOpen }, className);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: alertClasses, role: "alert" }, props, { children: [toggle && ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn-close", "aria-label": "Close", onClick: toggle })), children] })));
};
exports.Alert = Alert;
exports.default = exports.Alert;
